import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { ensureTabManagement, TabManagementUtil } from 'utils/TabManagementUtil';
import './InputLayer.less';
import { useOnClickOutside } from 'hooks/useOnOutsideClick';

export interface IInputLayerProps extends React.PropsWithChildren<React.HTMLProps<HTMLDivElement>> {
  onClickOutside?: () => void;
}

export const InputLayer = ({ children, className, onClickOutside, ...otherProps }: IInputLayerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const tabManager = useRef<TabManagementUtil>();

  useEffect(() => {
    // To keep focus inside the layer
    if (ref.current) {
      tabManager.current = ensureTabManagement(ref.current);
    }

    return () => {
      tabManager.current?.cleanupInstance();
    };
  }, []);

  useOnClickOutside(ref, onClickOutside);

  return (
    <div className={classNames('dp-input-layer', className)} ref={ref} {...otherProps}>
      <div className="dp-input-layer__content">{children}</div>
    </div>
  );
};
